// Pure display helpers for the 5-band credit-score visualization. The score itself
// comes from the backend's risk-engine (5C scoring) — this module only classifies an
// already-computed score into a band for rendering, it does not compute scores.

export interface ScoreBand {
  band: string;
  min: number;
  max: number;
  color: string;
  bgColor: string;
  borderColor: string;
  barColor: string;
  recommendation: string;
}

export const SCORE_BANDS: ScoreBand[] = [
  {
    band: 'Nguy cơ', min: 300, max: 450,
    color: 'text-red-600', bgColor: 'bg-red-50', borderColor: 'border-red-300', barColor: 'ring-red-400',
    recommendation: 'Không đủ điều kiện vay mới. Cần cải thiện lịch sử tín dụng và hoàn tất eKYC.',
  },
  {
    band: 'Rủi ro', min: 450, max: 550,
    color: 'text-orange-600', bgColor: 'bg-orange-50', borderColor: 'border-orange-300', barColor: 'ring-orange-400',
    recommendation: 'Chỉ xét duyệt khoản vay nhỏ, cần giám sát chặt và bổ sung tài sản đảm bảo.',
  },
  {
    band: 'Chú ý', min: 550, max: 650,
    color: 'text-amber-600', bgColor: 'bg-amber-50', borderColor: 'border-amber-300', barColor: 'ring-amber-400',
    recommendation: 'Có thể xét duyệt hạn mức vừa phải, theo dõi thêm lịch sử trả nợ.',
  },
  {
    band: 'Khá', min: 650, max: 760,
    color: 'text-teal-600', bgColor: 'bg-teal-50', borderColor: 'border-teal-300', barColor: 'ring-teal-400',
    recommendation: 'Đủ điều kiện xét duyệt hạn mức tiêu chuẩn.',
  },
  {
    band: 'Tốt', min: 760, max: 900,
    color: 'text-emerald-600', bgColor: 'bg-emerald-50', borderColor: 'border-emerald-300', barColor: 'ring-emerald-400',
    recommendation: 'Đủ điều kiện xét duyệt hạn mức cao, ưu tiên xử lý nhanh.',
  },
];

export function getScoreBand(score: number | null | undefined): ScoreBand {
  const s = score ?? 0;
  return SCORE_BANDS.find((b) => s >= b.min && s < b.max) || (s >= 900 ? SCORE_BANDS[SCORE_BANDS.length - 1] : SCORE_BANDS[0]);
}

export function getScoreBarPercent(score: number | null | undefined): number {
  const s = score ?? 0;
  return Math.max(0, Math.min(100, ((s - 300) / (900 - 300)) * 100));
}

export function getScoreBarColor(score: number | null | undefined): string {
  return getScoreBand(score).barColor;
}
